import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { backgroundImg } from "src/assets/assetsExport";
import { insights } from "../../data/insights";

function formatDate(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

export default function InsightsPage(): JSX.Element {
  const sorted = [...insights].sort(
    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
  );

  return (
    <>
      <Helmet>
        <title>Insights | Letting Engine</title>
        <meta
          name="description"
          content="Market commentary, tenant guides, and landlord advice on London luxury rentals from the Letting Engine team."
        />
      </Helmet>

      <section className="min-h-[60vh] pt-40 pb-20 w-full relative flex items-center justify-center overflow-hidden text-center">
        <img
          src={backgroundImg.social}
          alt=""
          className="absolute inset-0 w-full h-full object-cover opacity-15 filter grayscale contrast-125 pointer-events-none z-0"
        />
        <div className="relative z-10 max-w-4xl px-6">
          <h1 className="font-teko leading-tight mb-6 tracking-[-2px] text-6xl">
            <span className="stroke-1 text-text-slate">Insights</span>
          </h1>
          <p className="font-manrope text-base leading-relaxed text-text-slate max-w-2xl mx-auto">
            Practical guides and market commentary on London&apos;s luxury rental
            market — for tenants, landlords, and anyone relocating to the city.
          </p>
        </div>
      </section>

      <section className="py-24 px-[5%] bg-bg-porcelain">
        <div className="max-w-[1200px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
          {sorted.map((article) => (
            <article
              key={article.slug}
              className="bg-bg-white border border-solid border-[rgba(0,0,0,0.05)] p-8 shadow-soft transition-all duration-300 hover:-translate-y-1 hover:border-brand-yellow hover:shadow-[0_18px_50px_rgba(0,0,0,0.08)]"
            >
              <time
                dateTime={article.date}
                className="font-manrope text-xs uppercase tracking-wider text-text-slate"
              >
                {formatDate(article.date)}
              </time>
              <h2 className="font-teko text-3xl text-text-obsidian mt-3 mb-4 leading-tight">
                <Link
                  to={`/insights/${article.slug}`}
                  className="hover:text-brand-yellow transition-colors"
                >
                  {article.title}
                </Link>
              </h2>
              <p className="font-manrope text-sm text-text-slate leading-relaxed mb-6">
                {article.excerpt}
              </p>
              <Link
                to={`/insights/${article.slug}`}
                className="font-teko text-lg uppercase text-brand-yellow border-b border-brand-yellow hover:text-text-obsidian hover:border-text-obsidian transition-colors"
              >
                Read article
              </Link>
            </article>
          ))}
        </div>
      </section>
    </>
  );
}
